import { render, staticRenderFns } from "./ReceiptPayment.vue?vue&type=template&id=222071be&scoped=true"
import script from "./ReceiptPayment.vue?vue&type=script&lang=js"
export * from "./ReceiptPayment.vue?vue&type=script&lang=js"
import style0 from "./ReceiptPayment.vue?vue&type=style&index=0&id=222071be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222071be",
  null
  
)

export default component.exports